<template>
  <div class="container text-center w-100">
    <div class="welcome" >
      <!--<h1 class="text-primary font-weight-bold mb-3">Fox Video Downloader</h1>-->
      <!--<p class="h6 mb-5">Download YouTube(netflix, hulu..)to MP4 and other formats in one click.</p>-->
      <div class="d-flex align-items-center justify-content-center box1">
        <div class="mx-auto w-100" style="max-width: 980px;">
        <div class="d-flex flex-column flex-md-row mb-4">
          <input id="sf_url" v-model="url" type="text" placeholder="Paste the video link here, e.g. https://www.youtube.com/watch?v=ITH6ttdXBqk" onfocus="this.placeholder=''" onblur="this.placeholder='Paste the video link here, e.g. https://www.youtube.com/watch?v=ITH6ttdXBqk'" class="border border-primary w-100 p-3 my-2" />
          <a href="javascript:;" class="btn btn-primary rounded-0 my-2" @click="sniffer()"><span  class="h4 font-weight-bold">Download</span></a>
        </div>
        <p>By using this online video downloader, you accept our terms of service and agree not to download copyright-protected content.</p>
        </div>
      </div>
    </div>
    <div class="m-5">
      <snifferResult v-if="state==='snifferEnd'" :result="result"  @closeErrorDialogEvent="closeErrorDialogEvent"/>
    </div>

    <div class="swal-overlay swal-overlay--show-modal" tabindex="-1" v-if="state==='sniffering'">
      <div class="swal-modal swal-bg-transparent" role="dialog" aria-modal="true">
        <div class="swal-icon swal-icon--custom">
          <img src="../assets/loading.gif">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import https from "../https.js"
import snifferResult from "./snifferResult"
export default {
  name: 'app',
  components: {'snifferResult': snifferResult},
  data() {
    return {
      url: '',
      result: null,
      state: 'idle'
    }
  },
  methods:{
    sniffer: function(){
      this.state = 'sniffering';
      (async()=>{
        try{
          this.result = (await https.fetchGet('http://127.0.0.1:5000/sniffer', {'url': this.url})).data;
          debugger
        }catch(e){
          this.result = {'error': 'network error'}
        }
        this.state = 'snifferEnd' ;
      })();
      ga('send', {hitType: 'event',eventCategory: "PasteDownload",eventAction: this.getDomainFromUrl(this.url),eventLabel: this.url})
    },

    getDomainFromUrl(url){
      let domain = url.split('/');
      if(domain[0]){
        return domain[0];
      }
      else
      {
        return "invalid";
      }
    },

    closeErrorDialogEvent: function(){
      this.state = 'idle';
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/snifferMain.vue